<script setup lang="ts">
const props = defineProps({ blok: Object });

const questionModals = ref([
  {
    open: false,
    id: "farmers",
    label: props.blok?.farmers_modal_title,
    content: props.blok?.farmers_modal_description,
  },
  {
    open: false,
    id: "coops",
    label: props.blok?.coops_modal_title,
    content: props.blok?.coops_modal_description,
  },
  {
    open: false,
    id: "pisteurs",
    label: props.blok?.pisteurs_modal_title,
    content: props.blok?.pisteurs_modal_description,
  },
  {
    open: false,
    id: "traders",
    label: props.blok?.traders_modal_title,
    content: props.blok?.traders_modal_description,
  },
  {
    open: false,
    id: "processors",
    label: props.blok?.processors_modal_title,
    content: props.blok?.processors_modal_description,
  },
  {
    open: false,
    id: "manufacturers",
    label: props.blok?.manufacturers_modal_title,
    content: props.blok?.manufacturers_modal_description,
  },
  {
    open: false,
    id: "retailers",
    label: props.blok?.retailers_modal_title,
    content: props.blok?.retailers_modal_description,
  },
  {
    open: false,
    id: "consumers",
    label: props.blok?.consumers_modal_title,
    content: props.blok?.consumers_modal_description,
  },
]);

const openQuestionModal = (id: string) => {
  const modal = questionModals.value.find((modal: { id: string }) => modal.id === id);
  if (!modal) return;
  modal.open = true;
};
</script>

<template>
  <section class="section">
    <div class="px-6">
      <div class="bg-chsc-indigo-500 h-[70px] rounded-[60px]" />
      <div class="px-6">
        <div class="relative bg-[#FFC14A] pt-20 overflow-hidden">
          <div class="absolute top-[2950px] right-0 translate-x-[100px] max-[1281px]:hidden">
            <svg
              width="386"
              height="2454"
              viewBox="0 0 386 2454"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M385.87 0V80.3682C384.737 199.24 374.851 376.661 305.475 603.677C206.61 927.185 0 982.314 0 1175.21C0 1360.95 218.856 1400.24 305.475 1743.16C344.523 1897.75 385.123 2259.47 385.87 2443.89V2454C385.884 2450.69 385.884 2447.32 385.87 2443.89V80.3682C386.163 49.6061 385.87 22.7649 385.87 0Z"
                fill="#D9D9D9"
              />
              <path
                d="M385.87 0V80.3682C384.737 199.24 374.851 376.661 305.475 603.677C206.61 927.185 0 982.314 0 1175.21C0 1360.95 218.856 1400.24 305.475 1743.16C344.523 1897.75 385.123 2259.47 385.87 2443.89V2454C385.884 2450.69 385.884 2447.32 385.87 2443.89V80.3682C386.163 49.6061 385.87 22.7649 385.87 0Z"
                fill="#360086"
              />
            </svg>
          </div>
          <div class="absolute top-[2950px] left-0 translate-x-[-100px] max-[1281px]:hidden">
            <svg
              width="386"
              height="2454"
              viewBox="0 0 386 2454"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.130268 0V80.3682C1.26288 199.24 11.1489 376.661 80.5255 603.677C179.39 927.185 386 982.314 386 1175.21C386 1360.95 167.144 1400.24 80.5255 1743.16C41.4773 1897.75 0.877155 2259.47 0.130268 2443.89V2454C0.116272 2450.69 0.116361 2447.32 0.130268 2443.89V80.3682C-0.162835 49.6061 0.130268 22.7649 0.130268 0Z"
                fill="#D9D9D9"
              />
              <path
                d="M0.130268 0V80.3682C1.26288 199.24 11.1489 376.661 80.5255 603.677C179.39 927.185 386 982.314 386 1175.21C386 1360.95 167.144 1400.24 80.5255 1743.16C41.4773 1897.75 0.877155 2259.47 0.130268 2443.89V2454C0.116272 2450.69 0.116361 2447.32 0.130268 2443.89V80.3682C-0.162835 49.6061 0.130268 22.7649 0.130268 0Z"
                fill="#360086"
              />
            </svg>
          </div>
          <UiContainer class="relative">
            <header
              class="mb-12 font-londrina-solid text-center [&>h3]:text-white [&>h3]:fs-5xl [&>h3>strong]:fs-6xl [&>h3>strong]:text-chsc-indigo-500 [&>h3>strong]:font-normal"
            >
              <StoryblokRichText :doc="blok?.title" />
            </header>

            <div class="relative supply-question-row supply-question-row--centered z-1">
              <div class="relative supply-question__badge">
                <h4>{{ blok?.farmers_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.farmers_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('farmers')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
                <div class="absolute top-1/2 left-1/2 -translate-x-1/2 z-0 pointer-events-none max-[1025px]:hidden">
                  <svg
                    width="841"
                    height="557"
                    viewBox="0 0 841 557"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M141 31.5H127C82.8172 31.5 47 67.3172 47 111.5V517.5"
                      stroke="#FFD867"
                      stroke-width="61"
                    />
                    <path
                      d="M700 30.5H714C758.183 30.5 794 66.3172 794 110.5V516.5"
                      stroke="#FFD867"
                      stroke-width="61"
                    />
                    <path d="M47 556.5L87.7032 516.75H6.29681L47 556.5Z" fill="#FFD867" />
                    <path d="M794 555.5L834.703 515.75H753.297L794 555.5Z" fill="#FFD867" />
                  </svg>
                </div>
              </div>
            </div>
            <img
              v-motion-slide-visible-once-top
              src="https://a.storyblok.com/f/291812700015950/1388x585/477ca96b24/supply-questions-farmers-desktop.svg"
              alt="Supply Questions Farmers"
              class="absolute w-[1388px] left-1/2 -translate-x-1/2 max-w-none"
            />
            <div class="supply-question-row mt-[350px]">
              <div class="supply-question__badge">
                <h4>{{ blok?.coops_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.coops_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('coops')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
              </div>
              <img
                  v-motion-slide-visible-once-right
                  src="https://a.storyblok.com/f/291812700015950/525x520/1328159042/supply-questions-traders-left.svg"
                  class="-mt-32 hidden max-[1025px]:block"
                />
              <div class="supply-question__badge">
                <h4>{{ blok?.pisteurs_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.pisteurs_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('pisteurs')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
              </div>
              <img
                  v-motion-slide-visible-once-left
                  src="https://a.storyblok.com/f/291812700015950/379x439/7a6275eda7/supply-questions-traders-right.svg"
                  class="hidden max-[1025px]:block"
                />
            </div>
            <div class="mt-20 flex justify-center max-[1025px]:hidden">
              <svg
                width="810"
                height="190"
                viewBox="0 0 810 190"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M124.5 143H110.5C66.3172 143 30.5 107.183 30.5 63V-1.66893e-06"
                  stroke="#FFD867"
                  stroke-width="61"
                />
                <path
                  d="M685.5 143H699.5C743.683 143 779.5 107.183 779.5 63V-1.66893e-06"
                  stroke="#FFD867"
                  stroke-width="61"
                />
                <path d="M163.5 143L123.75 102.297L123.75 183.703L163.5 143Z" fill="#FFD867" />
                <path d="M647.5 142L687.25 101.297L687.25 182.703L647.5 142Z" fill="#FFD867" />
              </svg>
            </div>
            <div class="relative supply-question-row supply-question-row--centered mt-[-100px]">
              <div class="supply-question__badge">
                <h4>{{ blok?.traders_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.traders_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('traders')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
                <img
                  v-motion-slide-visible-once-right
                  src="https://a.storyblok.com/f/291812700015950/525x520/1328159042/supply-questions-traders-left.svg"
                  class="absolute right-full top-1/4 translate-x-[50px] max-w-none max-[1025px]:hidden"
                />
                <img
                  v-motion-slide-visible-once-left
                  src="https://a.storyblok.com/f/291812700015950/379x439/7a6275eda7/supply-questions-traders-right.svg"
                  class="absolute left-full top-1/4 translate-x-[-50px] max-w-none max-[1025px]:hidden"
                />
              </div>
            </div>
            <div class="flex justify-center my-20">
              <img
                v-motion-slide-visible-once-top
                src="https://a.storyblok.com/f/291812700015950/238x557/4d7652f02c/supply-questions-boat.svg"
              />
            </div>
            <div class="relative z-1 supply-question-row supply-question-row--centered">
              <div class="supply-question__badge">
                <h4>{{ blok?.processors_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.processors_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('processors')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
              </div>
            </div>
            <div class="flex justify-center mt-[-100px]  max-[1025px]:mt-0">
              <img
                v-motion-slide-visible-once-top
                src="https://a.storyblok.com/f/291812700015950/939x468/cedc3776db/supply-questions-processors.svg"
              />
            </div>
            <div class="flex justify-center mt-[-100px] mb-20">
              <img :src="blok?.questions_claim.filename" :alt="blok?.questions_claim.alt" />
            </div>
            <div class="relative supply-question-row supply-question-row--centered">
              <img
                v-motion-slide-visible-once-top
                src="https://a.storyblok.com/f/291812700015950/402x485/bc07b471ef/supply-questions-manufacturers-mobile.png"
                class="hidden max-[1025px]:block"
              />
              <div class="supply-question__badge max-[1025px]:-mt-44">
                <h4>{{ blok?.manufacturers_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.manufacturers_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('manufacturers')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
                <div class="absolute top-1/2 right-full translate-x-[-50px] translate-y-[-10px] max-[1025px]:hidden">
                  <svg
                    width="135"
                    height="320"
                    viewBox="0 0 135 320"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M134.703 30.5H120.703C76.5203 30.5 40.7031 66.3172 40.7031 110.5V281.5"
                      stroke="#FFD867"
                      stroke-width="61"
                    />
                    <path
                      d="M40.7031 319.5L81.4063 279.75H-6.86646e-05L40.7031 319.5Z"
                      fill="#FFD867"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="mt-[100px] supply-question-row">
              <img
                v-motion-slide-visible-once-top
                src="https://a.storyblok.com/f/291812700015950/402x600/50ea6819f8/supply-questions-retailer-mobile.png"
                class="hidden max-[1025px]:block"
              />
              <div class="supply-question__badge max-[1025px]:-mt-44">
                <h4>{{ blok?.retailers_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.retailers_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('retailers')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
                <div class="absolute top-1/2 left-full translate-x-[50px] max-[1025px]:hidden">
                  <svg
                    width="126"
                    height="94"
                    viewBox="0 0 126 94"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M126 47L86.25 6.29681L86.25 87.7032L126 47Z" fill="#FFD867" />
                    <line
                      x1="95"
                      y1="46.5"
                      x2="-2.66639e-06"
                      y2="46.5"
                      stroke="#FFD867"
                      stroke-width="61"
                    />
                  </svg>
                </div>
              </div>
              
              <div class="supply-question__badge">
                <h4>{{ blok?.consumers_badge_title }}</h4>
                <div class="supply-question__description">
                  <StoryblokRichText :doc="blok?.consumers_badge_description" />
                </div>
                <button class="supply-question__button" @click="openQuestionModal('consumers')">
                  <span class="supply-question__button-text">
                    {{ blok?.question_button }}
                  </span>
                </button>
              </div>
              <img
                v-motion-slide-visible-once-top
                src="https://a.storyblok.com/f/291812700015950/402x600/a866d51478/supply-questions-consumers-mobile.png"
                class="hidden max-[1025px]:block -mt-44"
              />
            </div>
          </UiContainer>
          <div class="flex justify-center">
            <img
              v-motion-slide-visible-once-top
              src="https://a.storyblok.com/f/291812700015950/1382x600/e6cc66183e/supply-questions-bottom.svg"
              class="max-[1025px]:hidden"
            />
          </div>
        </div>
      </div>
      <div class="bg-chsc-indigo-500 h-[70px] rounded-[60px]" />
    </div>
    <UModal
      v-for="modal in questionModals"
      :key="modal.id"
      :open="modal.open"
      :title="modal.label"
      dismissible
      :description="modal.label"
      :ui="{
        content: 'border border-chsc-indigo-500',
      }"
      class="max-w-4xl sm:max-w-4xl rounded-[40px] overflow-hidden"
    >
      <template #content>
        <div>
          <header
            :class="[
              `py-3.5 pl-20 pr-6 border-b border-chsc-indigo-500 flex items-center justify-between bg-chsc-yellow text-chsc-indigo-500`,
            ]"
          >
            <h3 class="fs-3xl font-eb-garamond font-medium">
              {{ modal.label }}
            </h3>
            <button
              class="flex items-center justify-center fs-xl cursor-pointer"
              @click="modal.open = false"
            >
              <UIcon name="i-heroicons-x-mark" />
            </button>
          </header>
          <div class="p-20 max-h-[75vh] overflow-y-auto global-text">
            <StoryblokRichText :doc="modal.content" />
          </div>
        </div>
      </template>
    </UModal>
  </section>
</template>
